import { createRouter, RouterProvider } from '@tanstack/react-router';
import { Center, Loader } from '@mantine/core';
import { routeTree } from '../routeTree.gen';
import { queryClient } from '@lib/queryClient';
import { useMsalRouterAuth } from '@features/auth/hooks/useMsalRouterAuth';

export type { AppRouterContext } from '@shared-types/router.types';

// Create router singleton
export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  scrollRestoration: true,
  context: undefined!, // Context will be provided by RouterProvider
});

/**
 * Register router for type safety
 */
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

/**
 * Inner component that provides auth context to router.
 * Must be rendered inside QueryClientProvider since useMsalRouterAuth uses useQueryClient.
 * Handles auth loading state before rendering router.
 */
export function AppRouter() {
  const auth = useMsalRouterAuth();

  // Wait for MSAL to initialize before rendering router
  if (auth.isLoading) {
    return (
      <Center h="100vh">
        <Loader size="lg"/>
      </Center>
    );
  }

  return <RouterProvider router={router} context={{auth, queryClient}}/>;
}
